<template>
  <div class="companies">
    <SectionHeader :companySelect="false">
      <template v-slot:breadcrumbs>
        <h1>
          <router-link to="/admin/users">{{ $t('companies.admin') }}</router-link>
          <router-link to="/admin/companies">{{ $t('meta.companies') }}</router-link>
          {{ templateMode == 'edit' ? company.name : $t('companies.addCompany') }}
        </h1>
      </template>
      <template v-slot:meta>
        <router-link to="/admin/companies" class="button button-grey button-round button-small">{{
          $t('companies.allCompanies')
        }}</router-link>
        <button
          v-if="templateMode == 'edit'"
          :disabled="!company.can_be_deleted || company.deleted_at != null"
          @click="removeCompany"
          class="button button-red button-small button-round"
        >
          {{ $t('companies.delete') }}
        </button>
      </template>
    </SectionHeader>

    <div class="body-content cf">
      <div class="entries-wrap">
        <AdminNav />
        <div class="body">
          <LoadingSpinner v-if="loading" full />

          <div v-else>
            <div class="content-wrap">
              <header class="content-header cf">
                <h3>{{ $t('containers.baseData') }}</h3>
              </header>
              <div class="content-body">
                <Form :initialCompany="company" @submit="submit" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Form from '@/views/admin/companies/Form.vue'

import LoadingSpinner from '@/components/LoadingSpinner'
import SectionHeader from '@/components/SectionHeader'
import AdminNav from '@/components/admin_nav'

import adminsApi from '@/api/admin'

export default {
  inject: ['showPopup'],
  components: {
    AdminNav,
    Form,
    LoadingSpinner,
    SectionHeader,
  },
  data: () => ({
    loading: true,
    company: {},
    templateMode: 'edit',
  }),
  methods: {
    async submit(company) {
      await adminsApi.companies.update(this.$route.params.uuid, company)
    },
    async removeCompany() {
      const confirmAlert = await this.showPopup({ content: this.$t('companies.deleteConfirmation'), type: 'confirm' })
      if (!confirmAlert) return

      const result = await adminsApi.companies.delete(this.company?.uuid)
      if (!result.success) return

      await this.$router.push({ name: 'admin_companies' })
    },
    async undoRemove() {
      const result = await adminsApi.companies.update(this.$route.params.uuid, { deleted_at: null })
      if (!result.success) return

      await this.$router.go()
    },
  },
  async mounted() {
    this.company = await adminsApi.companies.get(this.$route.params.uuid)
    this.loading = false
  },
}
</script>
